import React from "react";
import { Link } from "react-router-dom";

const FooterOne = () => {
  const phone = "+6587333600";

  const messageLinks = [
    {
      text: "Product Enquiry",
      msg: "Hi, I’m interested in your product. Can you provide more details on this product? I’d like to know about the price, specifications, and availability. Thanks!",
    },
    {
      text: "Related Order",
      msg: "Hello, I just placed an order with you. Can you please provide an update on the status or confirm when it will be shipped? Thanks!",
    },
    {
      text: "Related Payment",
      msg: "Hi, I recently made a payment for my order. I just wanted to confirm if the payment went through successfully. Can you check? Thanks!",
    },
    {
      text: "Shipping & Delivery",
      msg: "Hi, I’d like to inquire about the shipping status of my order. Can you provide the tracking details or let me know when it’s expected to arrive? Thanks!",
    },
    {
      text: "Return & Refund Order",
      msg: "Hello, I’d like to return or request a refund for my order. Could you guide me through the process? Thank you!",
    },
  ];

  return (
    <footer className="footer py-120">
      <div className="container container-md">
        <div className="footer-item-wrapper d-flex justify-content-between ms-auto me-0  align-items-start flex-wrap">
          <div className="footer-item">
            <div className="footer-item__logo">
              <Link to="/">
                {" "}
                <img src="/assets/images/logo/logo-pink-peony.png" alt="" />
              </Link>
            </div>
          </div>
          <div className="footer-item">
            <ul className="footer-menu">
              <li className="mb-16">
                <Link
                  to="/cart"
                  className="text-gray-600 hover-text-main-one-600"
                >
                  Shoping Cart
                </Link>
              </li>
              <li className="mb-16">
                <Link to="/" className="text-gray-600 hover-text-main-one-600">
                  Home
                </Link>
              </li>
              <li className="mb-16">
                <Link
                  to="/products"
                  className="text-gray-600 hover-text-main-one-600"
                >
                  Products
                </Link>
              </li>
              {/* <li className="mb-16">
                                <Link to="#" className="text-gray-600 hover-text-main-one-600">
                                    Track Shipment
                                </Link>
                            </li> */}
              <li className="mb-16">
                <Link
                  to="/contact"
                  className="text-gray-600 hover-text-main-one-600"
                >
                  Contact Us
                </Link>
              </li>
              <li className="mb-16">
                <Link
                  to="/wholesale/products"
                  className="text-gray-600 hover-text-main-one-600"
                >
                  Become Seller
                </Link>
              </li>
              <li className="mb-16">
                <Link
                  to="/free-delivery"
                  className="text-gray-600 hover-text-main-one-600"
                >
                  Free Delivery
                </Link>
              </li>
              <li className="mb-16">
                <Link
                  to="/account"
                  className="text-gray-600 hover-text-main-one-600"
                >
                  My Account
                </Link>
              </li>
            </ul>
          </div>
          <div className="footer-item ms-0 me-auto">
            <ul className="footer-menu">
              <li className="mb-16">
                <Link
                  to="/cart"
                  className="text-gray-600 hover-text-main-one-600"
                >
                  My Account
                </Link>
              </li>
              <li className="mb-16">
                <Link to="/" className="text-gray-600 hover-text-main-one-600">
                  Order History
                </Link>
              </li>
              <li className="mb-16">
                <Link
                  to="/cart"
                  className="text-gray-600 hover-text-main-one-600"
                >
                  Shoping Cart
                </Link>
              </li>

              <li className="mb-16">
                <Link
                  to="/account"
                  className="text-gray-600 hover-text-main-one-600"
                >
                  Customer Service
                </Link>
              </li>
            </ul>
          </div>
          <div className="footer-item">
            <h6 className="text-main-one-600">Get In Touch With Us</h6>
            <button
              type="button"
              className="chat_WA position-relative w-100 h-44 position-relative  d-flex text-white align-items-center justify-content-center mb-20"
              data-bs-toggle="modal"
              data-bs-target="#waModal"
            >
              <div className="WAicon position-absolute w-44 h-44 rounded-circle border-1">
                <i className="ph ph-whatsapp-logo"></i>
              </div>
              Chat via Whatsapp
              {/* <img src={`/assets/images/social/wa.png`} alt="" className='w-100 h-100 object-fit-contain' /> */}
            </button>
            <div className="d-flex align-items-center gap-12 flex-wrap">
              <Link
                to="/https://www.instagram.com"
                className="w-44 h-44 d-flex align-items-center justify-content-center rounded-circle"
              >
                <img
                  src={`/assets/images/social/ig.png`}
                  alt=""
                  className="w-100 h-100 object-fit-contain"
                />
              </Link>

              <Link
                to="/https://www.facebook.com"
                className="w-44 h-44 d-flex align-items-center justify-content-center rounded-circle"
              >
                <img
                  src={`/assets/images/social/fb.png`}
                  alt=""
                  className="w-100 h-100 object-fit-contain"
                />
              </Link>

              <Link
                to="/https://www.tiktok.com"
                className="w-44 h-44 d-flex align-items-center justify-content-center rounded-circle"
              >
                <img
                  src={`/assets/images/social/tiktok.png`}
                  alt=""
                  className="w-100 h-100 object-fit-contain"
                />
              </Link>

              <Link
                to="/https://www.telegram.com"
                className="w-44 h-44 d-flex align-items-center justify-content-center rounded-circle"
              >
                <img
                  src={`/assets/images/social/telegram.png`}
                  alt=""
                  className="w-100 h-100 object-fit-contain"
                />
              </Link>
            </div>
            <ul className="flex-align gap-16">
              <li>
                {/* <Link
                                    to={`https://api.whatsapp.com/send?phone=+6587333600&text=${encodeURIComponent("Hi! I'm interested in your product.")}`}
                                    className="w-44 h-44 d-flex align-items-center justify-content-center rounded-circle"
                                >
                                    <img src={`/assets/images/social/wa.png`} alt="" className='w-100 h-100 object-fit-contain' />
                                </Link> */}
              </li>
              {/* <li>
                                <Link
                                    to="/https://www.instagram.com"
                                    className="w-44 h-44 d-flex align-items-center justify-content-center rounded-circle"
                                >
                                    <img src={`/assets/images/social/ig.png`} alt="" className='w-100 h-100 object-fit-contain' />
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/https://www.facebook.com"
                                    className="w-44 h-44 d-flex align-items-center justify-content-center rounded-circle"
                                >
                                    <img src={`/assets/images/social/fb.png`} alt="" className='w-100 h-100 object-fit-contain' />
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/https://www.tiktok.com"
                                    className="w-44 h-44 d-flex align-items-center justify-content-center rounded-circle"
                                >
                                    <img src={`/assets/images/social/tiktok.png`} alt="" className='w-100 h-100 object-fit-contain' />
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/https://www.telegram.com"
                                    className="w-44 h-44 d-flex align-items-center justify-content-center rounded-circle"
                                >
                                    <img src={`/assets/images/social/telegram.png`} alt="" className='w-100 h-100 object-fit-contain' />
                                </Link>
                            </li> */}
            </ul>
          </div>
        </div>
      </div>

      {/* Modal Pilihan */}
      <div
        className="modal fade"
        id="waModal"
        tabIndex={-1}
        aria-labelledby="waModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content border-0 shadow">
            <div className="modal-header bg-main-one-900 text-white">
              <h5 className="modal-title text-white" id="waModalLabel">
                Select an Option
              </h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body text-center">
              <div className="list-group">
                {messageLinks.map((item, i) => (
                  <Link
                    key={i}
                    to={`https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(item.msg)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="list-group-item list-group-item-action"
                  >
                    {item.text}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterOne;
